export default "__VITE_ASSET__fd677950__"